/** 롱텀케어 자료요청 결과 모달 — caion_ltcs_* DB 컬럼 기준 (단일 소스) */

export type LtcsResultHeader = { title: string; key: string; sortable?: boolean };

export const LTCS_RECIPIENT_HEADERS: LtcsResultHeader[] = [
  { title: '수급자명', key: 'clsr_recipient_name', sortable: true },
  { title: '인정번호', key: 'clsr_approval_no', sortable: true },
  { title: '등급', key: 'clsr_grade', sortable: true },
  { title: '생년월일', key: 'clsr_birth_date', sortable: true },
  { title: '급여종류', key: 'clsr_service_type', sortable: true },
  { title: '계약시작일', key: 'clsr_enter_date', sortable: true },
  { title: '계약종료일', key: 'clsr_leave_date', sortable: true },
  { title: '연락처', key: 'clsr_phone', sortable: true },
  { title: '수집일시', key: 'clsr_wdate', sortable: true },
  { title: '수정일시', key: 'clsr_rdate', sortable: true },
];

export const LTCS_CAREGIVER_INFO_HEADERS: LtcsResultHeader[] = [
  { title: '성명', key: 'clci_name', sortable: true },
  { title: '생년월일', key: 'clci_birth_date', sortable: true },
  { title: '직종', key: 'clci_job_type', sortable: true },
  { title: '근무개월', key: 'clci_work_months', sortable: true },
  { title: '연락처', key: 'clci_phone', sortable: true },
  { title: '근무시작일', key: 'clci_work_start_date', sortable: true },
  { title: '근무종료일', key: 'clci_work_end_date', sortable: true },
  { title: '수집일시', key: 'clci_wdate', sortable: true },
];

export const LTCS_CAREGIVER_PLAN_HEADERS: LtcsResultHeader[] = [
  { title: '일자', key: 'clsp_date', sortable: true },
  { title: '시작', key: 'clsp_start_time', sortable: true },
  { title: '종료', key: 'clsp_end_time', sortable: true },
  { title: '수급자명', key: 'clsp_recipient_name', sortable: true },
  { title: '인정번호', key: 'clsp_recipient_cert_number', sortable: true },
  { title: '종사자명', key: 'clsp_caregiver_name', sortable: true },
  { title: '종사자생년', key: 'clsp_caregiver_birth', sortable: true },
  { title: '종사자번호', key: 'clsp_caregiver_number', sortable: true },
  { title: '종사자구분', key: 'clsp_caregiver_type', sortable: true },
  { title: '가족', key: 'clsp_is_family', sortable: false },
  { title: '가족관계', key: 'clsp_family_relation', sortable: true },
  { title: '급여종류', key: 'clsp_service_type', sortable: true },
  { title: '수가코드', key: 'clsp_fee_code', sortable: true },
  { title: '수가명', key: 'clsp_fee_name', sortable: true },
];

export const LTCS_RFID_HEADERS: LtcsResultHeader[] = [
  { title: '인정번호', key: 'clrf_cert_number', sortable: true },
  { title: '수급자명', key: 'clrf_recipient_name', sortable: true },
  { title: '요양보호사명', key: 'clrf_caregiver_name', sortable: true },
  { title: '구분', key: 'clrf_gubun', sortable: true },
  { title: '급여종류', key: 'clrf_service_type', sortable: true },
  { title: '급여제공년월', key: 'clrf_pay_ym', sortable: true },
  { title: '시작일시', key: 'clrf_start_dt', sortable: true },
  { title: '종료일시', key: 'clrf_end_dt', sortable: true },
  { title: '수정일시', key: 'clrf_update_dt', sortable: true },
  { title: '총시간', key: 'clrf_total_time', sortable: true },
  { title: '전송구분', key: 'clrf_send_type', sortable: true },
  { title: '사용여부', key: 'clrf_use_yn', sortable: true },
  { title: '신체활동', key: 'clrf_physical_act', sortable: false },
  { title: '인지자극활동', key: 'clrf_cognitive_stim', sortable: false },
  { title: '일상생활 함께하기', key: 'clrf_daily_together', sortable: false },
  { title: '인지행동변화 관리', key: 'clrf_cognitive_behavior', sortable: false },
  { title: '정서지원', key: 'clrf_emotional_support', sortable: false },
  { title: '가사 및 일상생활', key: 'clrf_housework_daily', sortable: false },
  { title: '신체기능', key: 'clrf_physical_func', sortable: false },
  { title: '식사기능', key: 'clrf_meal_func', sortable: false },
  { title: '인지기능', key: 'clrf_cognitive_func', sortable: false },
  { title: '대변실수횟수', key: 'clrf_stool_accident', sortable: false },
  { title: '소변실수횟수', key: 'clrf_urine_accident', sortable: false },
  { title: '특이사항', key: 'clrf_special_note', sortable: false },
  { title: '건강관리', key: 'clrf_health_mgmt', sortable: false },
  { title: '간호관리', key: 'clrf_nursing_mgmt', sortable: false },
  { title: '혈압', key: 'clrf_blood_pressure', sortable: false },
  { title: '맥박', key: 'clrf_pulse', sortable: false },
  { title: '체온', key: 'clrf_temperature', sortable: false },
];

export const LTCS_CLAIM_HEADERS: LtcsResultHeader[] = [
  { title: '연월', key: 'clc_year_month', sortable: true },
  { title: '일자', key: 'clc_date', sortable: true },
  { title: '계획시간', key: 'clc_plan_time', sortable: false },
  { title: '수급자명', key: 'clc_recipient_name', sortable: true },
  { title: '인정번호', key: 'clc_recipient_cert_number', sortable: true },
  { title: '종사자명', key: 'clc_caregiver_name', sortable: true },
  { title: '종사자생년', key: 'clc_caregiver_birth', sortable: true },
  { title: '종사자번호', key: 'clc_caregiver_number', sortable: true },
  { title: '종사자구분', key: 'clc_caregiver_type', sortable: true },
  { title: '가족', key: 'clc_is_family', sortable: false },
  { title: '가족관계', key: 'clc_family_relation', sortable: true },
  { title: '근무시간', key: 'clc_work_time', sortable: false },
  { title: '급여종류', key: 'clc_service_type', sortable: true },
  { title: '수가코드', key: 'clc_fee_code', sortable: true },
  { title: '수가명', key: 'clc_fee_name', sortable: true },
];

export const LTCS_CLAIM_DETAIL_HEADERS: LtcsResultHeader[] = [
  { title: '연월', key: 'clcd_year_month', sortable: true },
  { title: '상태', key: 'clcd_status', sortable: true },
  { title: '수급자명', key: 'clcd_recipient_name', sortable: true },
  { title: '인정번호', key: 'clcd_cert_number', sortable: true },
  { title: '일자', key: 'clcd_date', sortable: true },
  { title: '서비스시간', key: 'clcd_service_time', sortable: false },
  { title: '종사자명', key: 'clcd_caregiver_name', sortable: true },
  { title: '수가코드', key: 'clcd_fee_code', sortable: true },
  { title: '수가명', key: 'clcd_fee_name', sortable: true },
  { title: '수가', key: 'clcd_fee', sortable: true },
  { title: '감산점수', key: 'clcd_deduction_score', sortable: true },
  { title: '감산비율', key: 'clcd_deduction_rate', sortable: true },
];

export const LTCS_LABOR_COST_HEADERS: LtcsResultHeader[] = [
  { title: '년월', key: 'yearMonth', sortable: true },
  { title: '시설유형', key: 'facilityType', sortable: true },
  { title: '급여비용', key: 'totalCost', sortable: true },
  { title: '급여가산', key: 'totalAdd', sortable: true },
  { title: '인건비 비용', key: 'laborCost', sortable: true },
  { title: '인건비 가산', key: 'laborAdd', sortable: true },
  { title: '미반영 비용', key: 'nonLaborCost', sortable: true },
  { title: '미반영 가산', key: 'nonLaborAdd', sortable: true },
  { title: '본인부담금', key: 'selfPayCost', sortable: true },
];

export function getLtcsResultHeaders(type: string): LtcsResultHeader[] {
  switch (type) {
    case 'caion_ltcs_recipient_info':
      return LTCS_RECIPIENT_HEADERS;
    case 'caion_ltcs_emp_info':
      return LTCS_CAREGIVER_INFO_HEADERS;
    case 'caion_ltcs_schedule_plan':
      return LTCS_CAREGIVER_PLAN_HEADERS;
    case 'caion_ltcs_rfid':
      return LTCS_RFID_HEADERS;
    case 'caion_ltcs_claim':
      return LTCS_CLAIM_HEADERS;
    case 'caion_ltcs_claim_detail':
      return LTCS_CLAIM_DETAIL_HEADERS;
    case 'caion_ltcs_labor_cost':
      return LTCS_LABOR_COST_HEADERS;
    default:
      return LTCS_RECIPIENT_HEADERS;
  }
}
